import React from "react";
import { NavLink } from "react-router-dom";

import { Icon } from "../../shared/Icon/Icon";

interface Props {
  workspace: "room" | "desk";
}

export const GroupBookingWarning = ({ workspace }: Props) => {
  const label = workspace === "room" ? "Room" : "Desk";

  return (
    <div className="GroupForm__bookingNotice flex-a-center">
      <Icon icon="warning-triangle" />
      <p>
        {label} booking is disabled at the organization level. Enable it in{" "}
        <NavLink to="/settings/general/organization-settings">
          Organization Settings
        </NavLink>{" "}
        to allow this for groups.
      </p>
    </div>
  );
};
